<template>
  <Popup
    class="login-modal"
    v-model:show="show"
    v-bind="$attrs"
  >
    <div class="login-modal__content">
      <LoginContent @logged-in="onLogged" />
    </div>
    <div
      class="login-modal__close"
      @click="close"
    >
      <img
        src="@/assets/login/login-close-icon.svg"
        alt="close login modal"
      >
    </div>
  </Popup>
</template>

<script setup>
import { buriedPointUtil } from '@/utils/utils'
import Popup from '@/components/Popup/index.vue'
import { useLoginModal } from './hooks/useLoginModal'

import LoginContent from './LoginContent.vue'

const { show, close } = useLoginModal()
const emit = defineEmits(['close'])

watch(show, (val) => {
  if (val === false) {
    emit('close')
  }
})

onMounted(() => {
  buriedPointUtil({ eventId: 'PLG501' })
})

const onLogged = () => {
  close()
}
</script>

<style lang="less" scoped>
.login-modal {
  &__content {
    width: 400px;
    border-radius: 8px;
    overflow: hidden;
  }

  &__close {
    position: absolute;
    right: -32px;
    top: 0;
    cursor: pointer;

    > img {
      width: 24px;
      height: 24px;
    }
  }
}
</style>
